"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnakeLights = void 0;
const Adafruit_NeoPixel_1 = require("../../System/ArduinoLibraryClones/Adafruit_NeoPixel");
const ArduinoGlobals_1 = require("../../System/Simulator/ArduinoGlobals");
const DataStructures_1 = require("./DataStructures");
const strip_ = new Adafruit_NeoPixel_1.Adafruit_NeoPixel();
class SnakeLights {
    constructor(c) {
        this.cfg_ = c;
        this.NUM_LIGHTS = c.display.width * c.display.height;
        this.WIDTH = c.display.width;
        this.HEIGHT = c.display.height;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            ArduinoGlobals_1.Serial.println("Init Adafruit_NeoPixel...");
            strip_.updateLength(this.NUM_LIGHTS);
            strip_.updateType(this.cfg_.display.pixelType);
            strip_.setPin(this.cfg_.display.gpioPin);
            ArduinoGlobals_1.Serial.println("Done.");
            strip_.begin();
            // Top left set to red while booting.
            strip_.setPixelColor(0, Adafruit_NeoPixel_1.Adafruit_NeoPixel.Color(255, 0, 0));
            for (let i = 1; i < this.NUM_LIGHTS; i++) {
                strip_.setPixelColor(i, Adafruit_NeoPixel_1.Adafruit_NeoPixel.Color(0, 0, 0));
            }
            yield strip_.show();
        });
    }
    set_status_pixel(r, g, b) {
        this.clearWithoutFlush();
        strip_.setPixelColor(0, Adafruit_NeoPixel_1.Adafruit_NeoPixel.Color(r, g, b));
        strip_.show();
    }
    clearWithoutFlush() {
        for (let i = 0; i < this.NUM_LIGHTS; i++) {
            strip_.setPixelColor(i, Adafruit_NeoPixel_1.Adafruit_NeoPixel.Color(0, 0, 0));
        }
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearWithoutFlush();
            yield strip_.show();
        });
    }
    testPattern() {
        return __awaiter(this, void 0, void 0, function* () {
            for (let y = 0; y < this.HEIGHT; y++) {
                for (let x = 0; x < this.WIDTH; x++) {
                    yield this.update_pixel_by_coord(x, y, 255, 255, 255, true);
                }
            }
        });
    }
    log(pixel, r, g, b) {
        ArduinoGlobals_1.Serial.println(ArduinoGlobals_1.F("Updating lights."));
        ArduinoGlobals_1.Serial.print(pixel);
        ArduinoGlobals_1.Serial.print(ArduinoGlobals_1.F(":("));
        ArduinoGlobals_1.Serial.print(r);
        ArduinoGlobals_1.Serial.print(ArduinoGlobals_1.F(","));
        ArduinoGlobals_1.Serial.print(g);
        ArduinoGlobals_1.Serial.print(ArduinoGlobals_1.F(","));
        ArduinoGlobals_1.Serial.print(b);
        ArduinoGlobals_1.Serial.print(ArduinoGlobals_1.F(")\r\n"));
    }
    update_pixel_by_coord(x, y, r, g, b, autoFlush) {
        return __awaiter(this, void 0, void 0, function* () {
            if (x >= this.WIDTH || y >= this.HEIGHT) {
                return;
            }
            if (x < 0 || y < 0) {
                return;
            }
            const adjusted = SnakeLights.adjustXYToMatchDisplay(x, y, this.cfg_.display);
            let pixel_number = adjusted.pixel_number;
            strip_.setPixelColor(pixel_number, r, g, b);
            if (autoFlush) {
                yield strip_.show();
            }
        });
    }
    static adjustXYToMatchDisplay(x, y, config) {
        let adjustedX = x;
        let adjustedY = y;
        if (config.indexMode == DataStructures_1.index_mode.TOP_LEFT) {
            adjustedX = x;
        }
        else if (config.indexMode == DataStructures_1.index_mode.TOP_RIGHT) {
            adjustedX = ((config.width - 1) - x);
        }
        else if (config.indexMode == DataStructures_1.index_mode.BOTTOM_LEFT) {
            adjustedY = ((config.height - 1) - y);
        }
        else if (config.indexMode == DataStructures_1.index_mode.BOTTOM_RIGHT) {
            adjustedX = ((config.width - 1) - x);
            adjustedY = ((config.height - 1) - y);
        }
        if (config.carriageReturnMode == DataStructures_1.carriage_return_mode.REGULAR) {
            const pixel_number = adjustedX + (adjustedY * config.width);
            return { x: adjustedX, y: adjustedY, pixel_number: pixel_number };
        }
        if (config.carriageReturnMode == DataStructures_1.carriage_return_mode.SNAKED) {
            const shouldSnakeX = Math.floor(adjustedY % 2) == 1;
            if (shouldSnakeX) {
                adjustedX = ((config.width - 1) - adjustedX);
            }
            const pixel_number = adjustedX + (adjustedY * config.width);
            return { x: adjustedX, y: adjustedY, pixel_number: pixel_number };
        }
        if (config.carriageReturnMode == DataStructures_1.carriage_return_mode.SNAKED_VERTICALLY) {
            const shouldSnakeY = Math.floor(adjustedX % 2) == 1;
            if (shouldSnakeY) {
                adjustedY = ((config.height - 1) - adjustedY);
            }
            const pixel_number = adjustedY + (adjustedX * config.height);
            return { x: adjustedX, y: adjustedY, pixel_number: pixel_number };
        }
        return { x: -1, y: -1, pixel_number: -1 };
    }
    flush() {
        return __awaiter(this, void 0, void 0, function* () {
            yield strip_.show();
        });
    }
}
exports.SnakeLights = SnakeLights;
//# sourceMappingURL=snake_lights.js.map